<div class="dialog">
  <div class="dialog__header">
    <p>Agentes</p>
    <qr-input-autocomplete
      [config]="inputAutocompleteAgent"
      (selectedChange)="inputAutocompleteChange($event)"
    ></qr-input-autocomplete>
  </div>
  <div class="dialog__table">
    <!-- --------------------------------- -->
    <!-- ---------  TABLE HEADER  -------- -->
    <!-- --------------------------------- -->
    <div class="table-header-container" *ngIf="isTableHeaderVisible">
      <app-table-header-new
        class="table-header"
        [tableHeader]="tableHeader"
        [isCheckboxColumnVisible]="true"
        [orderByOrientationDefault]="order"
        (orderByChange)="tableOrderByChange($event)"
        (checkboxChange)="tableCheckboxChange($event)"
      ></app-table-header-new>
    </div>

    <!-- --------------------------------- -->
    <!-- -------  CONTENIDO TABLA  ------- -->
    <!-- --------------------------------- -->
    <div class="dialog__table-content" *ngIf="!isLoading">
      <div class="dialog__table-body">
        <div
          class="dialog__table-row"
          *ngFor="let reservation of reservationsList; let i = index"
          [ngClass]="reservation.cssClass"
        >
          <div
            class="dialog__table-column"
            [ngStyle]="{ width: setWidthColumn('checkbox') + '%' }"
          >
            <mat-checkbox
              [checked]="checked"
              color="primary"
              (change)="checkboxChange(reservation)"
            >
            </mat-checkbox>
          </div>
          <div
            class="dialog__table-column"
            [ngStyle]="{ width: setWidthColumn('address') + '%' }"
          >
            <p>{{ reservation.address }}</p>
          </div>
          <div
            class="dialog__table-column"
            [ngStyle]="{ width: setWidthColumn('expirationDate') + '%' }"
          >
            <p>
              {{
                this.utilsService.getFormattedDate(
                  reservation.expirationDate ?? ""
                )
              }}
            </p>
          </div>
          <div
            class="dialog__table-column"
            [ngStyle]="{ width: setWidthColumn('estimateCloseDate') + '%' }"
          >
            <p>
              {{
                this.utilsService.getFormattedDate(
                  reservation.estimateCloseDate
                )
              }}
            </p>
          </div>
          <div
            class="dialog__table-column"
            [ngStyle]="{ width: setWidthColumn('numReqUpd') + '%' }"
          >
            <p>{{ reservation.numReqUpd ? 0 : "-" }}</p>
          </div>
          <div
            class="dialog__table-column"
            [ngStyle]="{ width: setWidthColumn('lastReqUpdDate') + '%' }"
          >
            <p>{{ reservation.lastReqUpdDate ?? "-" }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- --------------------------------- -->
    <!-- -------  SKELETON LOADER  ------- -->
    <!-- --------------------------------- -->
    <div
      class="dialog__table-content dialog__table-content--skeleton"
      *ngIf="isLoading"
    >
      <div class="dialog__table-row" *ngFor="let row of [1, 2, 3, 4, 5]">
        <div
          class="dialog__table-column"
          *ngFor="let header of tableHeader; let i = index"
          [ngStyle]="{ width: header.percentageWidth + '%' }"
        >
          <qr-skeleton-loader></qr-skeleton-loader>
        </div>
      </div>
    </div>

    <!-- ------------------------------------>
    <!-- --------  BUTTONS  ----------------->
    <!-- ------------------------------------>
  </div>
</div>
<div class="footer">
  <qr-button [config]="buttonCancel" (click)="closeDialog()"></qr-button>
  <qr-button
    [config]="buttonActualizar"
    [isDisabled]="
      reservationsList.length === 0 || selectedReservations.length === 0
    "
    (click)="confirmProcess()"
  ></qr-button>
</div>
